import { atomWithStorage } from "jotai/utils";
import { useAtom } from "jotai";

const highlightModelValuesAtom = atomWithStorage<boolean>(
    "editor-highlight-model-values",
    false,
);

export function useHighlightModelValues() {
    const [highlightModelValues, setHighlightModelValues] = useAtom(
        highlightModelValuesAtom,
    );
    return { highlightModelValues, setHighlightModelValues };
}
